import { SC } from '../helper/ServerCall';

export const listTypeService = {
    getAllListTypes,
    getListTypeItem,
    storeListTypeItem,
    editListType,
    deleteListType,
    getParentData,
}

function getAllListTypes(page, filter, sort, pageSize) {
    return SC.getCall('list_type?page=' + page + '&filter=' + filter + '&sort=' + sort + '&pageSize=' + pageSize);
}

function getListTypeItem(id) {
    return SC.getCall('list_type/' + id);
}

function storeListTypeItem(listTypeData) {
    return SC.postCall('list_type', listTypeData);
}

function deleteListType(list_type_id) {
    return SC.deleteCall('list_type/' + list_type_id);
}

function editListType(listTypeData, list_type_id) {
    return SC.putCall('list_type/' + list_type_id, listTypeData);
}

function getParentData(parentId) {

    if (typeof parentId === 'undefined')
        return SC.getCall('get/parent');    
    else 
        return SC.getCall(`get/parent/${parentId}`);
}


// WEBPACK FOOTER //
// ./src/services/list-type.js